/* eslint-disable import/no-anonymous-default-export */
export default {
  translations: {
    HOME: {
      INITIAL_PAGE: "Pestaña de Inicio",
      UPDATED_AT: "Actualizado en",
      QUICK_ACCESS: "Acceso Rápido",
      SUPORT: "Soporte",
      CALL_CENTER: "Central de Atención",
      VEHICLE_ASSISTANCE: "Asistencia de Vehículos:",
      DOES_NOT_HAVE: "¿todavía no lo tienes?",
      CHAT_WITH_COMMERCIAL: "Chatea con nuestro asesor comercial.",
      GENERAL_DATA: "Datos Generales",
      SEARCH: "Buscar",
      COMMERCIAL: "Comercial",
      LANGUAGE: "Idioma",
      VEHICLE_NOT_SELECTED: "Vehículo no seleccionado",
      QUICK_CONTACT: "Contacto rápido",
      CONTACT_REGIONAL: "Regional",
      CONTACT_COMERCIAL: "Comercial",
      CONTACT_CENTRAL: "Central de Emergencia 24h",
    },
    TITLE: {
      DASHBOARD: "Dashboard de gestión",
      FILTERS: "Filtros",
      FILTER_CHARTS: "Filtro de gráficos",
      FILTER_PERIODS: "Período de búsqueda",
      FILTER_GROUPS: "Grupo de vehículos",
      MY_FLEET: "Mi Flota",
      MAP: "Mapa",
      MAIN_GRID: "Panel General (Grid)",
      DETAILED_POSITIONS: "Posiciones Detalladas",
      DRIVERS_REGISTERED: "Conductores Registrados",
      DRIVER_REGISTER: "Registro de Conductor",
      VEHICLES: "Vehículos",
      LOGS: "Registros",
      CLIENT_SEARCH: "Búsqueda de clientes",
      NEARBY_VEHICLES: "Vehículos cercanos",
    },
    MENU: {
      Home: "Inicio",
      Rastreamento: "Rastreo",
      Grupos: "Grupos",
      Controle: "Control",
      Atendimento: "Atención",
      Relatórios: "Reportes",
      Cadastro: "Registro",
      Manutenção: "Mantenimiento",
      Sistema: "Sistema",
    },
    DASHBOARD_CHARTS: {
      VEHICLE_STATUS: "Estado de los Vehículos",
      DRIVER_RANKING: "Clasificación de Conductores",
      GREATER_CIRCULATION: "Mayor Circulación",
      GREATER_IDLENESS: "Mayor Inactividad",
      IDLENESS_DESCRIPTION_ENGINE: "Motor Encendido",
      IDLENESS_DESCRIPTION_IDLE: "Detenido",
      IDLENESS_DESCRIPTION_OFF: "Motor Apagado",
      OUTSIDE_WORK_HOURS: "Fuera del Horario Laboral",
      OUTSIDE_WORK_HOURS_DESCRIPTION: "Fuera del Horario Laboral",
      INSIDE_WORK_HOURS_DESCRIPTION: "En Dentro del Horario Laboral",
      WEEKLY_CIRCULATION: "Circulación Semanal",
      SPEED_LIMIT: "Límite de Velocidad",
      TRANSIT_FINES: "Comparendos de Tránsito",
      SPEED_ABOVE_COMPANY_LIMIT: "Velocidad excedida a los límites de la empresa",
      SPEED_UP_TO_20_PERCENT_ABOVE: "Velocidad excedida hasta un 20% del límite de la vía (infracción moderada)",
      SPEED_BETWEEN_20_50_PERCENT_ABOVE: "Velocidad excedida entre 20% y 50% del límite de la vía (infracción grave)",
      SPEED_ABOVE_50_PERCENT: "Velocidad excedida por más de 50% del límite de la vía (infracción gravísima)",
    },
    DASHBOARD: {
      ACTIVE_VEHICLES: "Vehículos Activos",
      TOTAL_ODOMETER: "Odómetro Total",
      WORK_HOURS_DISTANCE: "Distancia en Horario Laboral",
      OUTSIDE_WORK_HOURS_DISTANCE: "Distancia Fuera del Horario Laboral",
      ENGINE_TIME: "Tiempo de Uso",
      IDLE_TIME: "Tiempo Detenido",
      OFF_TIME: "Tiempo Apagado",
      SPEED_LIMIT_DISTANCE: "Posiciones con Exceso de Velocidad",
      COMPANY_SPEED_LIMIT_DISTANCE: "Posiciones con Velocidad Excedida a los Límites de la Empresa",
      TOTAL_FINES: "Total de Comparendos",
    },
    TABLE_FINES: {
      DRIVER: "Conductor",
      DATE: "Fecha",
      VALUE: "Valor (COP$)",
      PLATE: "Placa",
    },
    FLEET: {
      BACK: "Volver",
      MAP: "Mapa",
      GRID_AND_MAP: "Grid + Mapa",
      ACTIONS: "Acciones",
      VIEW_MAP: "Ver mapa",
      OPEN_GOOGLE_MAPS: "Abrir Google Maps",
      BLOCK: "Bloqueo",
      ANCHOR: "Ancla",
      COMMANDS: "Comandos",
      CREATE_VISIT_POINT: "Crear Punto de Visita",
      AVAILABLE_COMMANDS: "Comandos disponibles",
      COMMAND_SENT: "Comando enviado",
      VEHICLE: "Vehículo",
      THIS_VEHICLE_HAS_BLOCK: "Este vehículo tiene bloqueo",
      COMMAND_HISTORY: "Historial de comandos",
      HISTORY: "Historial",
      NO_DATA_FOUND: "No se encontraron datos para el período seleccionado",
    },
    IGNITION: {
      ON: "Encendido",
      OFF: "Apagado",
    },
    SEARCH: {
      SEARCH: "Búsqueda",
      INITIAL_DATE_TIME: "Fecha y hora inicial",
      FINAL_DATE_TIME: "Fecha y hora final",
      UPDATE_PAGE: "Actualizar página",
      UPDATE: "Actualizar",
      INITIAL_TIME: "Hora Inicial",
      FINAL_TIME: "Hora Final",
    },
    MAINTENANCE: {
      MAINTENANCE: "Mantenimiento",
      REGISTER: "Registrar",
      REMOVE: "Remover",
      REGISTER_MAINTENANCE: "Registrar Mantenimiento",
      REMOVE_MAINTENANCE: "Remover Mantenimiento",
    },
    COMMANDS: {
      SEND_COMMANDS: "Enviar Comandos",
      COMMANDS: "Comandos",
      COMMAND_HISTORY: "Historial de Comandos",
      ANCHOR: "Ancla",
      BLOCK: "Bloqueo",
      UNLOCK: "Desbloqueo",
    },
    REPORTS: {
      REPORT_REQUEST: "Solicitud de reporte",
      NO_DATA_IN_RESPONSE: "La respuesta no contiene los datos necesarios.",
      FILTER_VALIDATION: "Validación de Filtros",
      ERROR_FETCHING_REPORT: "Error al buscar datos del reporte",
      SELECT_VEHICLE: "Selecciona un vehículo",
      VEHICLE_ACTIVITY_TITLE: "Reporte de Actividad de Vehículos",
    },
    REPORT_COLUMNS: {
      START: "Inicio",
      START_LOCATION: "Ubicación Inicial",
      END: "Fin",
      END_LOCATION: "Ubicación Final",
      TOTAL_DISTANCE: "Distancia total",
      TRAVEL_TIME: "Tiempo del Recurrido",
      REST_TIME: "Tiempo de descanso",
      AVG_SPEED: "Promedio de Velocidad",
      MAX_SPEED: "Velocidad máxima",
      DRIVER: "Conductor",
      PLATE: "Placa",
      DISTANCE: "Distancia",
      DAY_OF_WEEK: "Día de la Semana",
      DATE: "Fecha",
      IGNITION_ON: "Inicio",
      ENGINE_TIME: "Tiempo encendido",
      SAMPLES_ABOVE_SPEED: "Muestras con exceso de velocidad filtrada",
      SAMPLES_WITHIN_SPEED: "Muestras en dentro de la velocidad filtrada",
      DATE_TIME: "Fecha/Hora",
      STATUS: "Estado",
      IGNITION: "Ignición",
      EVENT: "Evento",
      SPEED: "Velocidad",
      LOCATION: "Ubicación",
      DURATION: "Duración",
      TYPE: "Tipo",
      PROTOCOL: "Protocolo",
      DESCRIPTION: "Descripción",
      OPENING_DATE: "Fecha de Apertura",
      SERVICE_DATE: "Fecha de Atención",
      CLOSING_DATE: "Fecha de Cierre",
      ATTENDANT: "Asesor",
      PROTOCOL_ID: "Protocolo",
      VEHICLE_ID: "VehÃ­culo",
      ALERT: "Alerta",
      TOTAL_ROWS: "Total de filas",
      TOTAL_PAGES: "Total de pÃ¡ginas",
      PAGE_NUMBER: "NÃºmero de pÃ¡gina",
      PAGE_SIZE: "TamaÃ±o de pÃ¡gina",
      ACCOUNT: "Cuenta",
      USER: "Usuario",
      MAIN_BATTERY: "Bat. Vehículo",
      BACKUP_BATTERY: "Bat. Rastreador",
    },
    ALERTS: {
      TITLE: "Alertas",
      DETAILS_BUTTON: "Ver detalles",
      MODAL_TITLE: "Detalles de la Alerta",
      COLUMNS: {
        PLATFORM: "Plataforma",
        PROTOCOL_ID: "Protocolo",
        CLIENT: "Cliente",
        CLIENT_ID: "ID de Cliente",
        DOCUMENT: "Documento",
        EVENT_DATE: "Fecha del Evento",
        SUBTYPE: "Subtipo",
        VEHICLE_ID: "Vehículo",
        PLATE: "Placa",
        LOCATION: "Ubicación",
        STATUS: "Estado",
        LAST_UPDATE: "Última Actualización",
        PHONE: "Teléfono",
        PHONE_2: "Teléfono 2",
      },
      FILTERS: {
        START_DATE: "Fecha Inicial",
        END_DATE: "Fecha Final",
        SEARCH: "Buscar",
      },
      MODAL: {
        INTERACTIONS_TITLE: "Interacciones",
        EMPTY_INTERACTIONS: "No hay interacciones registradas.",
        NEW_INTERACTION_PLACEHOLDER: "Escriba una nueva interacción...",
        ADD_INTERACTION_BUTTON: "Agregar interacción",
        STATUS_LABEL: "Estado de la alerta",
        SAVE_STATUS_BUTTON: "Guardar estado",
        INTERACTION_ADDED_SUCCESS: "Interacción agregada con éxito.",
        INTERACTION_ADD_ERROR: "No fue posible agregar la interacción.",
        STATUS_UPDATED_SUCCESS: "Estado actualizado con éxito.",
        STATUS_UPDATE_ERROR: "No fue posible actualizar el estado.",
      },
    },
    PROTOCOLS: {
      TITLE: "Protocolos",
      TOTAL_LABEL: "Total",
      ADD_BUTTON: "Agregar Protocolo",
      DETAILS_BUTTON: "Ver detalles",
      COLUMNS: {
        PROTOCOL_ID: "Protocolo",
        PLATFORM: "Plataforma",
        CLIENT: "Cliente",
        REGIONAL: "Regional",
        PLATE: "Placa",
        PLATE_ALIAS: "Alias de la Placa",
        TYPE: "Tipo",
        SUBTYPE: "Subtipo",
        STATUS: "Estado",
        EVENT_DATE: "Fecha del Evento",
        REMINDER_DATE: "Recordatorio",
        LAST_UPDATE: "Última Actualización",
      },
      FILTERS: {
        START_DATE: "Fecha Inicial",
        END_DATE: "Fecha Final",
        PLATE: "Placa",
        CLIENT: "Cliente",
        PROTOCOL_ID: "Protocolo",
        TYPE: "Tipo",
        SUBTYPE: "Subtipo",
        STATUS: "Estado",
        ALL: "Todos",
        SEARCH_BUTTON: "Filtrar",
      },
      MODAL: {
        CREATE_TITLE: "Nuevo Protocolo",
        DETAILS_TITLE: "Detalles del Protocolo",
        VEHICLE_LABEL: "Vehículo",
        TYPE_LABEL: "Tipo",
        SUBTYPE_LABEL: "Subtipo",
        DESCRIPTION_LABEL: "Descripción",
        EMAIL_LABEL: "Correo electrónico",
        STATUS_LABEL: "Estado",
        REMINDER_LABEL: "Recordatorio",
        SAVE_BUTTON: "Guardar",
        SAVE_STATUS_BUTTON: "Guardar estado",
        SAVE_REMINDER_BUTTON: "Guardar recordatorio",
        CREATE_SUCCESS: "Protocolo creado con éxito.",
        CREATE_ERROR: "No fue posible crear el protocolo.",
        DETAILS_UPDATED_SUCCESS: "Datos actualizados con éxito.",
        DETAILS_UPDATE_ERROR: "No fue posible actualizar los datos.",
        STATUS_UPDATED_SUCCESS: "Estado actualizado con éxito.",
        STATUS_UPDATE_ERROR: "No fue posible actualizar el estado.",
        REMINDER_UPDATED_SUCCESS: "Recordatorio actualizado con éxito.",
        REMINDER_UPDATE_ERROR: "No fue posible actualizar el recordatorio.",
        INTERACTIONS_TITLE: "Interacciones",
        EMPTY_INTERACTIONS: "No hay interacciones registradas.",
      },
    },
    PROTOCOL_SUMMARY: {
      TITLE: "Resumen de Protocolos",
      TOTAL_CLIENTS_LABEL: "Total de Clientes",
      TOTAL_PROTOCOLS_LABEL: "Total de Protocolos",
      PROTOCOLS_LINK: "Protocolos",
      FILTERS: {
        REGIONAL: "Regional",
      },
      COLUMNS: {
        CLIENT: "Cliente",
        REGIONAL: "Regional",
        EMAIL: "Login Master",
        QUANTITY: "Cantidad",
        OLDEST_PROTOCOL_DATE: "Protocolo Más Antiguo",
        ADMINISTRATIVE_RESTRICTION: "Restricción Administrativa",
      },
    },
    ERRORS: {
      FETCH_DATA_ERROR: "Error al buscar datos",
      FETCH_VEHICLES_STATUS_ERROR: "Error al buscar los estados de los vehículos:",
      COMMAND_EXECUTION_ERROR: "Error al ejecutar comando",
      FETCH_GROUPS_ERROR: "Error al buscar grupos:",
      CONFIG_NOT_FOUND: "No existe configuración para tu dominio. Envía un correo electrónico a <a href='mailto:contato@mirus.com.br'>contato@mirus.com.br</a>.",
      EMAIL_OR_PASS_INVALID: "Credenciales incorrectas. ¡Inténtelo otra vez!",
      LOGIN_FAILED: "No fue posible iniciar sesión. Revisa los datos utilizados.",
      EMAIL_FORMAT: "El correo electrónico ingresado no es válido",
      CONFIRM_PASS: "Las contraseñas deben coincidir",
      SEND_RECOVERY_MAILS: "Error al enviar contraseña. Inténtelo otra vez más tarde.",
      USER_NOT_FOUND: "Usuario no encontrado",
      USER_NOT_SELECTED: "Selecciona un inicio de sesión.",
      REQUIRED_FIELDS: "Completa todos los campos",
      RESET_NOT_POSSIBLE: "Error al intentar restablecer la contraseña, intenta nuevamente",
      KEY_PASS_INVALID: "Contraseña no encontrada, haz clic en el link recibido por correo electrónico",
      SEARCH_ERROR: "Error en la búsqueda.",
      FETCH_DRIVER_LIST_ERROR: "Error al buscar la lista de conductores",
      DELETE_DRIVER_ERROR: "Error al eliminar conductor",
      SAVE_DRIVER_ERROR: "Error al guardar datos del conductor",
      SAVE_LINK_ERROR: "Error al guardar vínculo del conductor",
      REMOVE_LINK_ERROR: "Error al eliminar vínculo del conductor",
    },
    COMMON: {
      CHART: "Gráfico",
      MIN: "Minimizar",
      MAX: "Maximizar",
      LOADING: "Cargando",
      SEARCH: "Buscar",
      SAVE: "Guardar",
      CLOSE: "Cerrar",
      BACK: "Volver",
      ERROR: "Error",
      SUCCESS: "Éxito",
      ATTENTION: "¡Atención!",
      NAME: "Nombre",
      DOCUMENT: "Documento",
      PLATE: "Placa",
      CPF_CNPJ: "Cédula/NIT",
      ID: "ID",
      TYPE: "Tipo",
      DESCRIPTION: "Descripción",
      DATE: "Fecha",
      NO_DATA_FOUND: "No se encontraron datos",
      YES: "Sí",  
      NO:  "No",  
    },
    LOGIN: {
      LOADING_SETTINGS: "Buscando configuraciones...",
      CONTACTS: "Contactos",
      SOWING_FUTURE: "Sembrando Futuro",
      LOGIN: "Iniciar sesión",
      USER: "Usuario",
      PASSWORD: "Contraseña",
      FORGOT_PASSWORD: "¿Olvidaste la contraseña?",
      ACCESS: "Acceder",
      ACCESSING: "Accediendo...",
      SELECT_ACCOUNT: "Selecciona una cuenta vinculada al inicio de sesión",
      ACCOUNTS: "Cuentas",
      BACK: "Volver",
      NEW_PASSWORD: "Nueva Contraseña",
      CONFIRM_PASSWORD: "Confirmar Contraseña",
      RESET_PASSWORD: "Restablecer Contraseña",
      RESETTING: "Restableciendo...",
      RESET: "Restablecer",
      PASSWORD_UPDATED_SUCCESS: "Contraseña actualizada con éxito",
      GO_TO_LOGIN_TEXT: "Haz clic en el botón para volver al inicio e iniciar sesión con la nueva contraseña",
      GO_TO_LOGIN: "Ir al Inicio de Sesión",
      PASSWORD_REMINDER: "Recordatorio de contraseña",
      REMINDER_SENT: "Recordatorio de contraseña enviado al correo {{email}}",
      EMAIL: "Correo electrónico",
      REMEMBER_PASSWORD: "Recordar contraseña",
      SENDING: "Enviando...",
      LOADING_TEXT: "Cargando...",
    },
    DRIVER: {
      NAME: "Nombre",
      DOCUMENT: "Documento",
      FUNCTIONAL_REGISTRY: "Registro funcional",
      RE: "RE",
      IBUTTON_KEY: "Clave iButton",
      LICENSE_NUMBER: "Número de la Licencia",
      LICENSE_CATEGORY: "Categoría de la Licencia",
      CNH: "Licencia de Conducción",
      CNH_CATEGORY: "Categoría de la Licencia",
      LICENSE_EXPIRATION: "Vencimiento de la Licencia",
      EXPIRATION: "Vencimiento",
      BIRTH_DATE: "Fecha de nacimiento",
      BIRTH: "Nacimiento",
      MOBILE_PHONE: "Celular",
      CELL_PHONE: "Celular",
      REGISTER: "Registro de Conductor",
      LINKED: "Vinculado",
      PLATE: "PLACA",
      IMPORT_SUCCESS: "Importación completada exitosamente",
    },
    CLIENT: {
      SEARCH_TITLE: "Búsqueda de clientes",
      FILL_FIELDS_TO_FILTER: "Completa los campos para filtrar la búsqueda",
      SOCIAL_NAME: "Razón Social",
      TRADE_NAME: "Nombre Comercial",
      PLATE_NICKNAME: "Apodo de la Placa",
      CONTRACT_STATUS: "Estado del Contrato",
    },
    LOGS: {
      OPERATION_TYPE: "Tipo de Operación",
      SEARCH_BUTTON: "Buscar",
    },
    BUTTONS: {
      SAVE: "Guardar",
      CLOSE: "Cerrar",
      CANCEL: "Cancelar",
      DELETE: "Eliminar",
      SEARCH: "Buscar",
      BACK: "Volver",
      UPDATE: "Actualizar",
    },
    VEHICLE_NICKNAME: {
      TITLE: "Vehículo/Apodo",
      EDIT_NICKNAME: "Editar Apodo",
      PLATE: "Placa",
      NICKNAME: "Apodo",
      DELETE: "Eliminar",
      CANCEL: "Cancelar",
      NICKNAME_OF_VEHICLE: "Apodo del vehículo",
    },
    LINKED_VEHICLES: {
      TITLE: "Vehículos Vinculados",
      FILTER_BY_GROUP: "Filtrar por Grupo",
      ALL_GROUPS: "Todos los grupos",
      FILTER_BY_PLATE: "Filtrar por Placa",
      ALL_PLATES: "Todas las placas",
      PLATE: "Placa",
      CURRENT_GROUP: "Grupo Actual",
      SELECT_A_GROUP: "Selecciona un grupo",
      CHANGED: "modificado",
      NO_VEHICLES_FOUND: "No se encontraron vehículos",
      SAVE_CHANGES: "Guardar cambios",
      CANCEL_CHANGES: "Cancelar cambios",
      NOTHING_TO_SAVE: "Nada para guardar",
      NO_CHANGES_TO_SAVE: "No hay cambios para guardar.",
      NO_RESPONSE: "Sin respuesta",
      FAILURES: "Fallas",
    },
    VIEW_MAP_FILTERS: {
      TITLE: "Radar",
      GROUPS: "Grupos",
      ALL_GROUPS: "Todos los grupos",
      VEHICLES: "Vehículos",
      ALL_VEHICLES: "Todos los vehículos",
      VIEW_VISITS: "Ver visitas",
      OPEN_VISUALIZATION: "Abrir visualización",
      HELP_TEXT: "Selecciona los filtros y haz clic en Abrir visualización para abrir el mapa en pantalla completa",
      RECENT_QUERIES:    "Últimas consultas",        
      NO_RECENT_QUERIES: "No se encontraron consultas recientes.", 
    },
    PROFILE: {
      TITLE: "Perfil",
      USER_PROFILE: "Perfil del usuario",
      PHONE: "Teléfono",
      NAME_REQUIRED: "El nombre es obligatorio.",
      EMAIL_REQUIRED: "El correo electrónico es obligatorio.",
      PHONE_REQUIRED: "El teléfono es obligatorio.",
      PHONE_INVALID: "Teléfono inválido. Formato esperado: (XX) XXXX-XXXX o (XX) 9XXXX-XXXX.",
      UPDATING: "Actualizando...",
      UPDATED_SUCCESS: "¡Perfil actualizado con éxito!",
      UPDATE_ERROR: "¡Ocurrió un error al intentar actualizar el perfil!",
      AVATAR_UPDATED: "Avatar actualizado, se actualizará después de iniciar sesión nuevamente",
    },
    ACCESS_PROFILE: {
      TITLE: "Perfil de Acceso",
      CREATED_PROFILES: "Perfiles Creados",
      CREATE_PROFILE: "Crear Perfil",
      CREATE_PROFILE_PLACEHOLDER: "Nombre del nuevo perfil",
      CREATE_BUTTON: "Crear",
      SELECT_PERMISSIONS: "Seleccione los permisos para este perfil:",
      SELECT_PROFILE_HINT: "Seleccione un perfil arriba para configurar sus permisos.",
      PROFILE_CREATED_SUCCESS: "Perfil creado con éxito.",
      PROFILE_CREATE_ERROR: "No fue posible crear el perfil.",
      PERMISSION_SAVED_SUCCESS: "Permiso actualizado con éxito.",
      PERMISSION_SAVE_ERROR: "No fue posible actualizar el permiso.",
      PROFILE_NAME_REQUIRED: "Ingrese un nombre para el nuevo perfil.",
      LOAD_PERMISSIONS_ERROR: "No fue posible cargar los permisos de este perfil.",
      CATALOG_NOT_LOADED_HINT: "Abra primero un perfil existente en la lista de arriba, para cargar las opciones disponibles.",
      DRAFT_HINT: "Perfil aún no creado. Marque los permisos deseados y confirme abajo.",
      CONFIRM_CREATE_PROFILE: "Crear Perfil con estos Permisos",
      CANCEL_SELECTION: "Cancelar",
    },
    CUSTOMER: {
      TITLE: "Clientes",
      SEARCH_INSTRUCTION: "Realice una búsqueda por Cédula/NIT o nombre del cliente que desea consultar o editar:",
      NEW_CUSTOMER: "Nuevo Cliente",
      SELECTED_CLIENT_LABEL: "Cliente seleccionado: #{{id}} — {{name}}",
      SEARCH_HINT: "Ingrese un nombre o Cédula/NIT y haga clic en Buscar.",
      FILL_SEARCH_HINT: "Ingrese un nombre o Cédula/NIT para buscar.",
      SEARCH_ERROR: "Error al buscar clientes.",
      COLUMN_NAME: "Nombre",
      COLUMN_TRADE_NAME: "Razón Social",
      COLUMN_ACTIVE_CONTRACTS: "Cant. Contratos Activos",
      COLUMN_REPRESENTATIVE: "Representante",
      TAB_PERSONAL_DATA: "Datos Personales / Administrativos",
      TAB_ADDRESS: "Dirección",
      TAB_CONTACTS: "Lista de Contactos",
      TAB_NOTES: "Observaciones",
      TAB_SETTINGS: "Configuraciones",
      TAB_COMMERCIAL_CONDITION: "Condición Comercial",
      TAB_LOCKED_TOOLTIP: "Guarde el cliente para desbloquear esta pestaña.",
      NEW_CUSTOMER_BLOCKED_HINT: "Complete los datos personales y guarde para desbloquear las demás pestañas.",
      TAB_ASSETS: "Activos",
      TAB_WIP: "Página aún en desarrollo.",
      NOTES: {
        CLIENT_TITLE: "OBSERVACIONES DEL CLIENTE",
        CLIENT_LABEL: "DESCRIBA LA OBSERVACIÓN A CONTINUACIÓN:",
        CLIENT_PLACEHOLDER: "",
        OPERATIONAL_TITLE: "OBSERVACIONES OPERACIONALES",
        OPERATIONAL_PLACEHOLDER: "",
        BILLING_TITLE: "OBSERVACIONES DE FACTURACIÓN",
        BILLING_PLACEHOLDER: "",
        BILLING_EMAILS_LABEL: "LISTA DE CORREOS DE COBRANZA:",
        BILLING_EMAILS_PLACEHOLDER: "",
        LOADING: "Cargando observaciones...",
        LOAD_ERROR: "No se pudieron cargar las observaciones del cliente.",
        EDIT: "EDITAR",
        SAVE: "GUARDAR",
      },
      SETTINGS: {
        SYSTEM_TITLE: "SISTEMA",
        EVENTS_BY_PHONE: "EVENTOS COMUNICADOS POR LA CENTRAL POR TELÉFONO (SI NO, SE ENVIARÁ UN CORREO)",
        BILLING_TITLE: "COBRANZA",
        BILLING_EMAIL_ALERT: "ENVÍO DE CORREO, ALERTA DE VENCIMIENTOS Y ATRASOS",
        BILLING_SMS_ALERT: "ENVÍO DE SMS, ALERTA DE VENCIMIENTOS Y ATRASOS",
        AUTO_RESTRICTION: "RESTRICCIÓN AUTOMÁTICA POR FALTA DE PAGO",
        AUTHORIZE_NEGATIVATION: "AUTORIZAR REPORTE A CENTRALES DE RIESGO",
        SAVE: "GUARDAR",
      },
      COMMERCIAL_CONDITION: {
        DUE_DAY: "DÍA DE VENCIMIENTO",
        NEXT_DUE_DATE: "PRÓXIMO VENCIMIENTO",
        CUTOFF_DAY: "DÍA DE CORTE",
        PREVIOUS_CYCLE_START: "INICIO CICLO ANTERIOR",
        PREVIOUS_CYCLE_END: "FIN CICLO ANTERIOR",
        CURRENT_CYCLE_START: "INICIO CICLO ACTUAL",
        CURRENT_CYCLE_END: "FIN CICLO ACTUAL",
        BILLING_VALIDATED_BY_CLIENT: "VALIDACIÓN DE FACTURACIÓN POR EL CLIENTE",
        SELECT: "Seleccione",
        SAVE: "GUARDAR",
        SELECT_CONDITION_TITLE: "SELECCIONE LA CONDICIÓN COMERCIAL",
        TYPE: "TIPO",
        PLAN_VALIDITY: "VIGENCIA DEL PLAN",
        NEXT_READJUSTMENT: "PRÓXIMO REAJUSTE",
        CONTRACTED_SERVICE_TITLE: "SERVICIO CONTRATADO",
        SUGGESTED_VALUE: "VALOR SUGERIDO",
        INSTALLMENT_TITLE: "CUOTAS Y FORMA DE PAGO",
        INSTALLMENT_PLAN: "CUOTAS",
        PAYMENT_METHOD: "FORMA DE PAGO",
        LOAD_CATALOGS_ERROR: "No fue posible cargar las opciones de esta pantalla.",
        LOAD_FEATURES_ERROR: "No fue posible cargar los servicios contratados.",
        SELECT_CONDITION_HINT: "Seleccione la Condición Comercial arriba para ver los servicios contratados.",
        CONDITION_LABEL: "CONDICIÓN COMERCIAL",
        PAYMENT_VALUES_TITLE: "VALORES Y FORMAS DE PAGO DE SERVICIOS",
        TOTAL_SERVICES: "TOTAL DE SERVICIOS",
        TOTAL_PLAN: "TOTAL DEL PLAN",
        PERIODICITY: "PERIODICIDAD",
        MONTHLY_FEE: "MENSUALIDAD",
        PAYMENT_METHOD: "FORMA DE PAGO",
        INSTALLATION_VALUE_TITLE: "VALOR DE INSTALACIÓN",
        EQUIPMENT_VALUE_TITLE: "VALOR DEL EQUIPO",
        VALUE: "VALOR",
        INSTALLMENTS: "PLAZOS",
        FINES_TITLE: "VALORES DE MULTAS Y VISITAS IMPRODUCTIVAS",
        CONTRACT_TERMINATION_FINE: "MULTA POR RESCISIÓN",
        TECHNICAL_VISIT: "VISITA TÉCNICA",
        WITHDRAWAL: "RETIRO",
        UNPRODUCTIVE_VISIT: "VISITA IMPRODUCTIVA",
        VEHICLE_EXCHANGE: "CAMBIO DE VEHÍCULO",
        CLEAR: "LIMPIAR",
        REGISTERED_CONDITIONS_TITLE: "CONDICIONES COMERCIALES REGISTRADAS",
        COLUMN_PLAN: "PLANES",
        COLUMN_MONTHLY_FEE: "MENSUALIDAD",
        COLUMN_CONTRACTS_QTY: "CANT. CONTRATOS",
        EDIT: "EDITAR",
        DEACTIVATE: "DESACTIVAR",
      },
      CONTACTS_LIST: {
        PAGE_TITLE: "Registro de Contactos",
        TRUST_HINT:
          "Los contactos registrados deben ser de confianza, son la segunda opción que Mirus tendrá para comunicarse.",
        SELECT_PLACEHOLDER: "Seleccione",
        PHONE_LABEL: "Teléfono",
        EMAIL_LABEL: "Correo",
        CLEAR: "Limpiar",
        NAME_REQUIRED: "Ingrese el nombre del contacto.",
        RELATIONSHIP_REQUIRED: "Este campo es obligatorio.",
        PHONE_REQUIRED: "Este campo es obligatorio.",
        EMAIL_REQUIRED: "Este campo es obligatorio.",
        CONTACT_CREATED: "Contacto creado con éxito.",
        CONTACT_UPDATED: "Contacto actualizado con éxito.",
        CONTACT_DELETED: "Contacto eliminado con éxito.",
        REGISTERED_TITLE: "Contactos Registrados",
        LOAD_CONTACTS_ERROR: "No fue posible cargar los contactos de este cliente.",
        EDIT: "Editar",
        DELETE: "Eliminar",
        PHONES_TITLE: "Teléfonos",
        EMAILS_TITLE: "Correos",
        ADD_PHONES_TITLE: "Agregar Teléfonos",
        ADD_EMAILS_TITLE: "Agregar Correos",
        COLUMN_ACTIONS: "Acciones",
        COLUMN_NUMBER: "Número",
        REMOVE: "Eliminar",
        NO_PHONES: "Ningún teléfono registrado.",
        NO_EMAILS: "Ningún correo registrado.",
        EXTENSION: "ext.",
        RELATIONSHIP_UNKNOWN: "Vínculo no informado",
        DOC_LABEL: "Cédula/NIT",
        SAVE_CONTACT_ERROR: "No fue posible guardar el contacto.",
        SAVE_PHONE_ERROR: "No fue posible guardar el teléfono.",
        DELETE_PHONE_ERROR: "No fue posible eliminar el teléfono.",
        SAVE_EMAIL_ERROR: "No fue posible guardar el correo.",
        DELETE_EMAIL_ERROR: "No fue posible eliminar el correo."},
      PERSONAL_DATA: {
        SECTION_CLIENT_DATA: "Datos del Cliente",
        CLIENT_TYPE: "Tipo de Cliente",
        CLIENT_TYPE_PF: "Persona Física",
        CLIENT_TYPE_PJ: "Persona Jurídica",
        SIMPLE_TAX: "Régimen Simplificado",
        SECTION_FINANCIAL: "Financiero",
        CREDIT_ANALYSIS: "Análisis de Crédito",
        CREDIT_ANALYSIS_APPROVED: "Aprobado",
        CREDIT_ANALYSIS_REJECTED: "Rechazado",
        DDA: "DDA",
        INSTALLMENT_BOOKLET: "Carné de Cuotas",
        SECTION_RESTRICTION: "Restricción Administrativa",
        RESTRICTION_TYPE: "Tipo de Restricción",
        SECTION_COMMERCIAL: "Responsable Comercial",
        REPRESENTATIVE: "Representante",
        COMMERCIAL: "Comercial",
        CLIENT_ID: "ID Cliente",
        DOC: "CIF/NIF",
        CLIENT_NAME: "Razón Social",
        CLIENT_TRADE_NAME: "Nombre Comercial",
        STATE_REGISTRATION: "Inscripción Estatal",
        MUNICIPAL_REGISTRATION: "Inscripción Municipal",
        BIRTH_DATE: "Fecha Nac./Const.",
        EMAIL: "Correo Electrónico",
        PHONE: "Teléfono",
        CELLPHONE: "Celular",
        CREATED_AT: "Fecha de Registro",
        UPDATED_AT: "Última Actualización",
        RESTRICTION_START_DATE: "Fecha de Inicio",
        RESTRICTION_END_DATE: "Fecha de Fin",
        LAST_SUSPENSION_DATE: "Última Suspensión",
        SOURCE_TBD: "Fuente de datos a definir.",
        LOAD_PLANS_ERROR: "No fue posible cargar los planes de servicio.",
        LOAD_CLIENT_ERROR: "No fue posible cargar los datos del cliente.",
        LOAD_RESTRICTIONS_ERROR: "No fue posible cargar los tipos de restricción.",
        LOAD_REPRESENTATIVES_ERROR: "No fue posible cargar los representantes.",
        LOAD_SALESPEOPLE_ERROR: "No fue posible cargar los comerciales.",
        BILLING_BUTTON: "Facturación",
        REQUIRED_FIELDS_ERROR: "Complete los campos obligatorios (Nombre y CIF/NIF) antes de guardar.",
        CLIENT_NAME_REQUIRED: "El nombre es obligatorio.",
        DOC_REQUIRED: "El CIF/NIF es obligatorio.",
        REQUIRED_FIELDS_HINT: "Campos obligatorios",
        UPDATING: "Guardando...",
        UPDATED_SUCCESS: "¡Cliente guardado con éxito!",
        UPDATE_ERROR: "¡Ocurrió un error al guardar el cliente!",
      },
      ASSETS: {
        PAYER_HINT: "* Para poder cambiar la condición comercial, seleccione el cliente pagador.",
        SEARCH_PAYER_TITLE: "Buscar Cliente Pagador",
        CLEAR: "Limpiar",
        STATUS_LABEL: "Seleccione el Estado",
        SELECT_PLACEHOLDER: "Seleccione",
        TOTAL_CONTRACTS: "Total de Contratos",
        SEARCH_CONTRACTS: "Buscar Contratos",
        RESULTS_TITLE: "Contratos del Cliente Seleccionado",
        SEARCH_HINT: "Ingrese los filtros y haga clic en Buscar Contratos.",
        COLUMN_CONTRACT: "Contrato",
        COLUMN_PLATE: "Placa",
        COLUMN_SERIAL: "Serie",
        COLUMN_REGISTERED_AT: "Fecha de Registro",
        COLUMN_ACTIVATED_AT: "Fecha de Activación",
        COLUMN_LAST_CHANGE_AT: "Última Modificación",
        COLUMN_STATUS: "Estado",
        COLUMN_COMMERCIAL_CONDITION: "Condición Comercial",
        COLUMN_ACTIONS: "Acciones",
        DETAILS_BUTTON: "Detalles",
        DETAILS_TITLE: "Detalles del Contrato",
        DETAILS_WIP: "Pantalla de detalles del contrato {{contractId}} aún no implementada."
      },
      ADDRESS: {
        MAIN_TITLE: "REGISTRO DE DIRECCIÓN PRINCIPAL",
        BILLING_TITLE: "REGISTRO DE DIRECCIÓN DE FACTURACIÓN",
        SAME_AS_MAIN: "Igual que la dirección principal.",
        CEP: "CÓDIGO POSTAL",
        STREET: "DIRECCIÓN",
        NUMBER: "NÚMERO",
        NEIGHBORHOOD: "BARRIO",
        COMPLEMENT: "COMPLEMENTO",
        UF: "ESTADO",
        CITY: "CIUDAD",
        INVALID_CEP: "Ingrese un código postal válido.",
        CEP_NOT_FOUND: "Código postal no encontrado.",
        CEP_SEARCH_ERROR: "Error al buscar el código postal.",
        CEP_FOUND: "Código postal encontrado.",
        LOAD_ERROR: "No fue posible cargar la dirección del cliente.",
        SAVING: "Guardando...",
        SAVE_ERROR: "No fue posible guardar la dirección.",
        SAVED_SUCCESS: "¡Dirección guardada con éxito!",
      },
    },
    DRIVER_PROFILE: {
      VEHICLES: "Vehículos",
    },
    LOGS_CONTROL: {
      ID: "Id",
      TYPE: "Tipo",
      DESCRIPTION: "Descripción",
      DATE: "Fecha",
    },
    GROUP_USERS: {
      TITLE: "Vincular usuarios a grupos",
      GROUPS: "Grupos",
      SELECT_ALL: "Seleccionar Todos",
      REMOVE_ALL: "Remover Todos",
      USER: "Usuario",
      EMAIL: "Correo electrónico",
      BIND: "Vincular",
      SAVE: "Guardar",
      SAVING: "Guardando...",
      LOADING_USERS: "Cargando usuarios del grupo...",
      PROCESSING: "Procesando...",
      SELECT_GROUP_MESSAGE: "Seleccione un grupo para ver los usuarios.",
      NO_USERS_FOUND: "No se encontraron usuarios en este grupo.",
      NO_MARKER_SELECTED: "Ningún marcador seleccionado.",
      NO_GROUP_SELECTED: "Ningún grupo seleccionado.",
      CHANGES_SAVED: "cambio(s) guardado(s) con éxito.",
      SAVE_ERROR: "No se pudieron guardar los cambios.",
      REQUEST_ERROR: "Fallo en la solicitud.",
    },
    TRANSPORT_CLIENTS: {
      PAGE_TITLE: "Clientes",
      LIST_TITLE: "Empresas registradas",
      ADD_NEW: "Agregar",
      EDIT_TITLE: "Editar Empresa",
      NEW_TITLE: "Nueva Empresa",
      COMPANY_NAME: "Nombre de la Empresa",
      CNPJ: "CNPJ",
      PHONE_1: "Tel. Principal",
      PHONE_2: "Tel. Secundario",
      EMAIL: "Correo electrónico",
      SEND_NON_CONFORMITY_EMAIL: "Enviar informe de no conformidad cuando la línea sea concluida.",
      SEND_CONFORMITY_EMAIL: "Incluir las conformidades en el informe enviado.",
      SEND_COPY: "Recibir copia del informe enviado al cliente.",
      SAVE: "Guardar",
      CANCEL: "Cancelar",
      ACTIONS: "Acciones",
      EDIT: "Editar",
      DELETE: "Eliminar",
      COMPANY_NAME_REQUIRED: "El nombre de la empresa es obligatorio.",
      CNPJ_REQUIRED: "El CNPJ es obligatorio.",
      CNPJ_INVALID: "CNPJ inválido.",
      EMAIL_REQUIRED: "El correo electrónico es obligatorio.",
      EMAIL_INVALID: "Correo electrónico inválido.",
      LOGIN: "Login",
      LAST_ACCESS: "Último Acceso",
      NO_RECORDS_FOUND: "Ningún registro encontrado",
      LOAD_ERROR: "Error al cargar empresas",
      SAVE_ERROR: "Ocurrió un error al guardar la empresa.",
      SAVE_SUCCESS_NEW: "¡Empresa registrada con éxito!",
      SAVE_SUCCESS_EDIT: "¡Empresa actualizada con éxito!",
      DELETE_SUCCESS: "¡Empresa eliminada con éxito!",
      DELETE_ERROR: "Ocurrió un error al eliminar la empresa.",
      LAST_ACCESS_DATE: "Última fecha de acceso",
    },
    TRANSPORT_PATHS: {
      PAGE_TITLE: "Líneas",
      LIST_TITLE: "Líneas registradas",
      ADD_NEW: "Agregar",
      EDIT_TITLE: "Editar Línea",
      NEW_TITLE: "Nueva Línea",
      COMPANY: "Nombre de la Empresa",
      SELECT_COMPANY: "Seleccione una empresa",
      SELECT_COMPANY_MESSAGE: "Seleccione una empresa para ver sus líneas.",
      NAME: "Nombre de la Línea",
      PURPOSE: "Finalidad",
      SELECT_PURPOSE: "Seleccione",
      PURPOSE_ENTRY: "Entrada",
      PURPOSE_EXIT: "Salida",
      DAYS: "Seleccione los días de operación de la línea",
      SUNDAY: "Domingo",
      MONDAY: "Lunes",
      TUESDAY: "Martes",
      WEDNESDAY: "Miércoles",
      THURSDAY: "Jueves",
      FRIDAY: "Viernes",
      SATURDAY: "Sábado",
      START_TIME: "Horario Inicial",
      END_TIME: "Horario Final",
      GROUP: "Grupo",
      ALL_GROUPS: "Todos",
      VEHICLE: "Vehículo",
      SELECT_VEHICLE: "Seleccione",
      SAVE: "Guardar",
      CANCEL: "Cancelar",
      CLEAR: "Limpiar",
      ACTIONS: "Acciones",
      EDIT: "Editar",
      DELETE: "Eliminar",
      LINE_COLUMN: "Línea",
      START_COLUMN: "Inicio",
      END_COLUMN: "Fin",
      WEEK_COLUMN: "Semana",
      VEHICLE_COLUMN: "Vehículo",
      NAME_REQUIRED: "El nombre de la línea es obligatorio.",
      PURPOSE_REQUIRED: "La finalidad es obligatoria.",
      VEHICLE_REQUIRED: "El vehículo es obligatorio.",
      NO_RECORDS_FOUND: "Ninguna línea encontrada",
      LOAD_ERROR: "Error al cargar líneas",
      SAVE_ERROR: "Ocurrió un error al guardar la línea.",
      SAVE_SUCCESS_NEW: "¡Línea registrada con éxito!",
      SAVE_SUCCESS_EDIT: "¡Línea actualizada con éxito!",
      DELETE_SUCCESS: "¡Línea eliminada con éxito!",
      DELETE_ERROR: "Ocurrió un error al eliminar la línea.",
      REPROCESS_DAILY: "Reprocesar Diarios",
      REPROCESS_SUMMARY: "Reprocesar Resumen",
      START_DATE: "Fecha Inicial",
      END_DATE: "Fecha Final",
      EXPORT_FILE: "Exportar Archivo",
      FEATURE_NOT_AVAILABLE: "Funcionalidad aún no disponible.",
    },
    NOTIFICATIONS_CONFIG: {
      PAGE_TITLE: "Notificaciones",
      LIST_TITLE: "Configuración de Notificaciones",
      SELECT_ALL: "Seleccionar Todos",
      DESELECT_ALL: "Desmarcar Todos",
      NO_RECORDS_FOUND: "Ninguna notificación encontrada",
      LOAD_ERROR: "Error al cargar notificaciones",
      SAVE_ERROR: "Ocurrió un error al actualizar la notificación.",
      SAVE_SUCCESS: "¡Notificación actualizada con éxito!",
    },
    GROUPS: {
      PAGE_TITLE: "Registro de Grupos",
      LIST_TITLE: "Lista de Grupos",
      REGISTER_TITLE: "Datos del Grupo",
      DELETE_ERROR_TITLE: "Error al eliminar",
      DELETE_ERROR_TEXT: "Grupo en uso, eliminación no permitida.",
      FILTERS: "Filtros",
      SELECT_GROUP: "Selecciona un grupo",
      CURRENT_GROUP: "Grupo Actual",
      NO_VEHICLES_FOUND: "No se encontraron vehículos",
      ACTION_CONFIRMED: "¡Acción confirmada!",
      CONFIRM: "Confirmar",
      DESCRIPTION: "Descripción",
      DEFAULT: "Predeterminado",
      DEFINE_DEFAULT: "Definir como Predeterminado",
      DELETE: "Eliminar",
      SELECT_GROUP_REQUIRED: "Seleccione un grupo de destino para mover los vehículos antes de eliminar.",
      MOVE_VEHICLES_ERROR: "No se pudieron mover los vehículos al nuevo grupo. Se canceló la eliminación.",

    },
    MODAL_VISITS: {
      TITLE: "Vehículos Cercanos",
      GRID: "Cuadrícula",
      MAP: "Mapa",
      PLATE: "Placa",
      MODEL: "Modelo",
      DISTANCE: "Distancia (m)",
      LAST_POSITION: "Última Posición",
      EXPORT_PDF: "Exportar PDF",
      EXPORT_EXCEL: "Exportar Excel",
      NO_VEHICLES_NEARBY: "No se encontraron vehículos cercanos",
    },
    VISIT_CONTROL: {
      TITLE: "Control de Visitas",
      NEW_VISIT: "Nueva Visita",
      EDIT_VISIT: "Editar Visita",
      VISIT_NAME: "Nombre de la Visita",
      ADDRESS: "Dirección",
      RADIUS: "Radio (m)",
      CATEGORY: "Categoría",
      SAVE_SUCCESS: "Visita guardada con éxito",
      DELETE_SUCCESS: "Visita eliminada con éxito",
    },
    VISIT_POINTS: {
      TITLE: "Puntos de Visita",
      POINT_NAME: "Nombre del Punto",
      COORDINATES: "Coordenadas",
      CREATED_AT: "Creado En",
      VIEW_MARKER: "Ver marcador",
      EDIT_MARKER: "Editar marcador",
      CREATE_MARKER: "Crear marcador por:",
      ADDRESS: "Dirección",
      COORDINATE: "Coordenada",
      NAME: "Nombre",
      RADIUS: "Radio (m)",
      RADIUS_SELECT: "-- Radio --",
      ADDRESS_PLACEHOLDER: "Escriba la dirección...",
      LATITUDE: "Latitud",
      LONGITUDE: "Longitud",
      EDIT: "Editar",
      DISPLAY: "Mostrar",
      INSERT: "Insertar",
      UPDATE: "Actualizar",
      MARKER_PLACEHOLDER: "Marcador",
      SELECT_ADDRESS: "Seleccione una dirección",
      EDIT_COORDINATE: "Editar Coordenada",
      PROCESSING: "Procesando...",
      CANCEL: "Cancelar",
      SAVE: "Guardar",
      SAVING: "Guardando...",
      CONFIRM_DELETE: "Confirmar eliminación",
      DELETE_MESSAGE: "¿Desea realmente eliminar la dirección",
      DELETE: "Eliminar",
      VISIT_POINTS: "Puntos de visita",
      MAP: "Mapa",
      MAP_HEADER: "Mapa",
    },
    REGISTER_VEHICLE: {
      TITLE: "Registro de Vehículos",
      VEHICLE_DATA: "Datos del Vehículo",
      LICENSE_PLATE: "Placa",
      CHASSIS: "Chasis",
      MODEL: "Línea",
      YEAR: "Modelo",
      COLOR: "Color",
      SAVE_SUCCESS: "Vehículo guardado con éxito",
    },
    CONTROL_POINTS: {
      TITLE: "Puntos de Control",
      NEW_POINT: "Nuevo Punto",
      POINT_NAME: "Nombre del Punto",
      DESCRIPTION: "Descripción",
      TYPE: "Tipo",
    },
    VEHICLES_CONFIG: {
      TITLE: "Configuraciones de Vehículos",
      GENERAL: "General",
      NOTIFICATIONS: "Notificaciones",
      SPEED_LIMIT: "Límite de Velocidad",
      FUEL: "Combustible",
      MAINTENANCE: "Mantenimiento",
    },
    RISK_AREA: {
      TITLE: "Áreas de Riesgo",
      NEW_AREA: "Nuevo Área",
      AREA_NAME: "Nombre del Área",
      DANGER_LEVEL: "Nivel de Peligro",
      LOW: "Bajo",
      MEDIUM: "Mediano",
      HIGH: "Alto",
      CRITICAL: "Crítico",
      GRID: "Cuadrícula",
      MAP: "Mapa",
      DESCRIPTION: "Descripción",
      LOCATION: "Ubicación",
      ACTIONS: "Acciones",
      EDIT: "Editar",
      DELETE: "Eliminar",
      VIEW: "Ver",
      SEARCH_ADDRESS: "Buscar dirección",
      DRAW_POLYGON: "Dibujar polígono",
      EDIT_MODE: "Modo de edición activado",
      SAVE_AREA: "Guardar Área",
      UPDATE_AREA: "Actualizar Área",
      CLEAR: "Limpiar",
      SAVE: "Guardar",
      SAVING: "Guardando...",
      CANCEL: "Cancelar",
      CLOSE: "Cerrar",
      CONFIRM_DELETE: "Confirmar eliminación",
      DELETE_MESSAGE: "¿Desea realmente eliminar el área",
      AREA_DESCRIPTION: "Descripción del área",
      POLYGON_DESCRIPTION: "Descripción del polígono",
      BIND_VEHICLES: "Vincular Vehículos",
      RISK_AREAS: "Áreas de riesgo",
      POLYGON_FENCES: "Geocercas Poligonales",
      ADDRESS_PLACEHOLDER: "Escriba ciudad, barrio o dirección…",
      SEARCH: "Buscar",
    },
    ELETRONIC_FENCES: {
      TITLE: "Geocercas Electrónicas",
      NEW_FENCE: "Nueva Geocerca",
      CREATE_FENCE: "Crear geocerca",
      EDIT_FENCE: "Editar geocerca",
      FENCE_NAME: "Nombre de la Geocerca",
      FENCE_TYPE: "Tipo de Geocerca",
      CIRCULAR: "Circular",
      POLYGONAL: "Poligonal",
      ACTIVE: "Activa",
      INACTIVE: "Inactiva",
      ALERT_ON_ENTRY: "Alerta al Entrar",
      ALERT_ON_EXIT: "Alerta al Salir",
      GRID: "Cuadrícula",
      MAP: "Mapa",
      DESCRIPTION: "Descripción",
      LOCATION: "Ubicación",
      RADIUS: "Radio (m)",
      ACTIONS: "Acciones",
      EDIT: "Editar",
      DELETE: "Eliminar",
      VIEW: "Ver",
      ORIGIN: "Origen",
      DESTINATION: "Destino",
      BUFFER_WIDTH: "Ancho de la cerca (m)",
      CALCULATE_ROUTE: "Calcular ruta",
      APPLY_BUFFER: "Aplicar",
      SAVE: "Guardar",
      SAVING: "Guardando...",
      CANCEL: "Cancelar",
      CLOSE: "Cerrar",
      CONFIRM_DELETE: "Confirmar eliminación",
      DELETE_MESSAGE: "¿Desea realmente eliminar la geocerca",
      // eslint-disable-next-line no-dupe-keys
      EDIT_FENCE: "Editar Geocerca",
      VIEW_FENCE: "Ver Geocerca",
      // eslint-disable-next-line no-dupe-keys
      CREATE_FENCE: "Crear Geocerca Electrónica",
      BIND_VEHICLES: "Vincular Vehículos",
      BIND_GROUPS: "Vincular Grupos",
      VEHICLE_GROUPS: "Grupos de Vehículos",
      SELECT_GROUP: "Seleccione un grupo",
      VEHICLES: "Vehículos",
      SELECT_VEHICLES: "Seleccione vehículos",
      SAVE_BINDINGS: "Guardar Vínculos",
      ORIGIN_FENCE: "Origen de la geocerca",
      DESTINATION_FENCE: "Destino de la geocerca",
      ORIGIN_FENCE_EDITED: "Origen de la geocerca editada",
      DESTINATION_FENCE_EDITED: "Destino de la geocerca editada",
      ERROR_ROUTE_DRAW: "Error al trazar la ruta",
      ERROR_LOAD_FENCE_DATA: "Error al cargar los datos de la geocerca. Inténtelo nuevamente.",
      FENCE_DELETED_SUCCESS: "Geocerca eliminada con éxito.",
      FENCE_DELETE_FAIL: "No fue posible eliminar la geocerca.",
      UNEXPECTED_DELETE_FAILURE: "Falla inesperada al eliminar.",
      REVERSE_GEOCODING_ERROR: "Error en la geocodificación inversa",
      PLEASE_ENTER_FENCE_DESCRIPTION: "Por favor, ingrese una descripción para la geocerca electrónica",
      INVALID_POLYGON_TITLE: "Polígono inválido",
      INVALID_POLYGON_MIN_POINTS: "El polígono debe tener al menos 3 puntos",
      SAVED_SUCCESS: "Guardado con éxito",
      ERROR_UPDATE_FENCE: "Error al actualizar la geocerca electrónica. Inténtelo nuevamente.",
      INCOMPLETE_POINTS_TITLE: "Puntos incompletos",
      DEFINE_ORIGIN_DESTINATION_BEFORE_SAVE: "Defina origen y destino antes de guardar",
      ROUTE_NOT_CALCULATED_TITLE: "Ruta no calculada",
      CALCULATE_ROUTE_BEFORE_SAVE: "Calcule la ruta antes de guardar",
      ERROR_SAVE_FENCE: "Error al guardar la geocerca electrónica. Inténtelo nuevamente.",
      GENERATED_BY_MAP: "Geocerca electrónica generada por el mapa",
      FENCE_UPDATED_TITLE: "Geocerca Actualizada",
      FENCE_UPDATED_SUCCESS: "Geocerca electrónica actualizada con éxito",
      ERROR_UPDATE_FENCE_SHORT: "Error al actualizar la geocerca electrónica",
      ERROR_LOADING_FENCES: "Error al cargar las geocercas. Inténtelo nuevamente.",
      FENCE_NOT_FOUND: "Geocerca no encontrada",
      ERROR_LOADING_EDIT_DATA: "Error al cargar datos para edición",
      DELETE_WITHOUT_LINKED_VEHICLE_MSG: "Para eliminar una geocerca, no puede tener ningún vehículo vinculado",
      NO_VEHICLES_FOUND_FOR_POINT: "No se encontraron vehículos para este punto.",
      AREA_DESCRIPTION_PLACEHOLDER: "Ej.: Área de riesgo - Zona Norte",
      EDITING: "Editando",
      CLICK_MAP_DEFINE: "Definir con clic en el mapa:",
      ORIGIN_INPUT_LABEL: "Origen (escriba/seleccione o haga clic en el mapa)",
      DESTINATION_INPUT_LABEL: "Destino (escriba/seleccione o haga clic en el mapa)",
      ORIGIN_PLACEHOLDER: "Av. Paulista, 1000, São Paulo…",
      DESTINATION_PLACEHOLDER: "Praça da Sé, São Paulo…",
      SWAP: "Invertir",
      CLEAR: "Limpiar",
      ORIGINAL_ROUTE: "Ruta original",
      ELECTRONIC_FENCE: "Geocerca Electrónica",
      ERROR_CALCULATE_ROUTE: "Error al calcular la ruta. Verifique si los puntos de origen y destino están definidos.",
      LOADING_FENCES: "Cargando geocercas electrónicas...",
      BIND_UNBIND: "Vincular / Desvincular",
      VIEW_ON_MAP: "Ver en mapa",
    },
    ROUTING: {
      TITLE: "Rutas",
      VIEW_MAP: "Ver mapa",
      COPY_LINK: "Copiar enlace",
      GENERATE_FENCE: "Generar cerca electrónica",
      ADD_POINT: "Agregar punto",
      TYPE_ADDRESS: "Dirección",
      TYPE_COORDINATE: "Coordenada",
      TYPE_VISIT_POINT: "Punto de visita",
      LATITUDE: "Latitud",
      LONGITUDE: "Longitud",
      LOADING_VISIT_POINTS: "Cargando puntos de visita...",
      SELECT_VISIT_POINT: "Seleccione un punto de visita",
      ERROR_CALCULATE_ROUTE: "Error al calcular la ruta. Verifique que los puntos de origen y destino estén definidos.",
      LINK_COPIED: "Enlace copiado al portapapeles",
      LINK_COPY_ERROR: "Error al copiar el enlace",
      MAX_POINTS_REACHED: "Número máximo de puntos alcanzado (25)",
    },
    VEHICLE_NEAREST: {
      TITLE: "Vehículo más cercano",
      SELECT_METHOD: "Seleccione la forma en que desea encontrar el vehículo más cercano",
      ADDRESS: "Dirección",
      VEHICLE: "Vehículo",
      VISIT_POINT: "Punto de Visita",
      ENTER_ADDRESS: "Escriba la dirección que desea",
      LOCATE_ADDRESS: "Localizar dirección",
      NO_ADDRESS_FOUND: "No se encontró información para la dirección ingresada",
      SELECT_VEHICLE_DISTANCE: "Seleccione el vehículo del que desea calcular la distancia desde el punto",
      GROUPS: "Grupos",
      ALL_GROUPS: "Todos los grupos",
      VEHICLES: "Vehículos",
      ALL_VEHICLES: "Todos los vehículos",
      FILTER: "Filtrar",
      GROUP: "Grupo",
      DATE_TIME: "Fecha/Hora",
      NO_VEHICLE_INFO: "No se encontró información para los vehículos del usuario",
      SELECT_POINT: "Seleccione el punto donde desea localizar el vehículo más cercano",
      SEARCH_RADIUS: "Radio de Búsqueda",
      FOUND_VEHICLES: "Vehículos Encontrados",
      NO_VEHICLES: "No se encontraron vehículos en el área",
    },
    FILTERS_COMPONENT: {
      MINIMUM_DURATION: "Duración Mínima",
      TYPE: "Tipo",
      BOTH: "Ambos",
      VISIT_POINT: "Punto de Visita",
      STOP_POINT: "Punto de Parada",
      ALL: "Todos",
      COMPANY_SPEED_ONLY: "Solamente la velocidad de la empresa",
      ROAD_SPEED_MODERATE: "Exceso de velocidad máxima permitida por la vía - infracción moderada",
      ROAD_SPEED_SERIOUS: "Exceso de velocidad máxima permitida por la vía - infracción grave",
      ROAD_SPEED_VERY_SERIOUS: "Exceso de velocidad máxima permitida por la vía - infracción gravísima",
      ROAD_SPEED_ALL: "Exceso de velocidad máxima permitida por la vía - todas las infracciones",
      VEHICLE: "Vehículo",
      ALL_VEHICLES: "Todos los vehículos",
      DRIVERS: "Conductores",
      ALL_DRIVERS: "Todos los conductores",
      START: "Inicio",
      END: "Fin",
      START_DATE_TIME: "Fecha y hora de inicio",
      END_DATE_TIME: "Fecha y hora de fin",
      REPORTS: "Reportes",
      DISPLAY: "Mostrar",
      EXCEL: "Excel",
      PDF: "PDF",
    },
    CLIENT_DETAILS: {
      PAGE_TITLE: "Detalle del cliente",
      VIEW_CLIENT: "Ver Cliente",
      FANTASY_NAME: "Nombre Comercial",
      SHORT_NAME: "Nombre Abreviado",
      FULL_NAME: "Nombre Completo",
      SOCIAL_NAME: "Razón Social",
      IDENTIFICATION: "Identificación",
      ADDRESS: "Dirección",
      ADDRESS_2: "Dirección 2",
      COMPANY_REGISTRATION: "Registro de la empresa",
      PHONE_1: "Teléfono 1",
      PHONE_2: "Teléfono 2",
      OBSERVATION: "Observación",
      NUMBER: "Número",
      NEIGHBORHOOD: "Barrio o Localidad",
      COMPLEMENT: "Complemento",
      STATE: "Departamento",
      CITY: "Ciudad",
      ZIP_CODE: "Código Postal",
      CNPJ: "NIT",
      STATE_REGISTRATION: "Inscripción Estatal",
      MUNICIPAL_REGISTRATION: "Inscripción Municipal",
      SIMPLE_TAX_OPTANT: "Optante del Régimen Simplificado",
      PUBLIC_COMPANY: "Empresa Pública",
      YES: "Sí",
      NO: "No",
      PERSON_TYPE: "Tipo de Persona",
      INDIVIDUAL: "Persona Física",
      COMPANY: "Persona Jurídica",
    },
    TABLE: {
      DEFAULT: "Predeterminado",
      ACTIONS: "Acciones",
      FILTER: "Filtrar",
      GLOBAL_SEARCH: "Búsqueda global",
      LOAD_DATA_ERROR: "Error al cargar los datos",
      SELECT_OPTION: "Selecciona una opción para mostrar los datos.",
    },
    USER_NAV: {
      USER_PROFILE: "Perfil del Usuario",
      CHANGE_PASSWORD: "Cambiar Contraseña",
      CLIENT_USERS: "Usuarios del Cliente",
      COMPANY: "Empresa",
      NOTIFICATIONS: "Notificaciones",
      FILL_BOTH_FIELDS: "Complete ambos campos",
      PASSWORDS_MUST_MATCH: "Ambas contraseñas deben coincidir",
      PASSWORD_CHANGED: "Contraseña cambiada",
      PASSWORD_CHANGED_SUCCESS: "Contraseña cambiada con éxito",
      PASSWORD_CHANGE_ERROR: "Error al cambiar la contraseña, intente nuevamente más tarde",
    },
    DELETE_MODAL: {
      CONFIRM_DELETE: "¿Deseas realmente eliminar?",
      OK: "Ok",
    },
    MESSAGE_MODAL: {
      WARNING: "¡Aviso!",
    },
    INFO_WINDOW: {
      VEHICLE: "Vehículo",
      MODEL: "Línea",
      MANUFACTURER: "Fabricante",
      YEAR: "Modelo",
      CATEGORY: "Categoría",
      ADDRESS: "Dirección",
      STATUS: "Estado",
      EVENT: "Evento",
      DRIVER: "Conductor",
      IGNITION_BATTERY: "Ignición (Batería)",
      GROUP: "Grupo",
      SPEED: "Velocidad",
      ODOMETER: "Odómetro",
      TIME_ELAPSED: "Tiempo Transcurrido",
      TRACKER_BATTERY: "Batería del Rastreador",
      VEHICLE_BATTERY: "Batería del Vehículo",
    },
    MAINTENANCES: {
      MAINTENANCE_ITEM: {
        DESCRIPTION: "Agregue el ítem del que desea tener control de uso",
        INPUT_PLACEHOLDER: "Escriba el nombre del ítem",
        BTN_SAVE: "Guardar Nuevo",
        BTN_CANCEL: "Cancelar",
        FIELD_TABLE_ITEM: "Ítem",
        FIELD_TABLE_EDIT: "Editar",
        FIELD_TABLE_DELETE: "Eliminar",
      },
      SCHEDULING: {
        DESCRIPTION: "Agregue el ítem que desea programar para el mantenimiento",
        ITEMS: "Ítems",
        SELECT_ITEM: "Seleccione un ítem",
        SCHEDULING: "Programación",
        SINGLE_ENTRY: "Entrada Única",
        DATE: "Fecha",
        KM: "Km",
        OR: "O",
        SELECT: "Seleccionar",
        DAYS: "días",
        MAINTENANCE_COST: "Costo de Mantenimiento",
        UPDATE: "Actualizar",
        SAVE: "Guardar",
        SAVING: "Guardando...",
        CLEAR: "Limpiar",
        VEHICLE: "Vehículo",
        ITEM: "Ítem",
        TIME_DAYS: "Tiempo (días)",
        ADDED: "Agregado",
        ACTIONS: "Acciones",
        NO_ITEMS_SCHEDULED: "No hay ítems programados",
      },
      COMPLETED: {
        TITLE: "Mantenimientos Completados",
        DESCRIPTION: "Seleccione el vehículo y escriba el período",
        UNTIL: "Hasta",
        SEARCH: "Buscar",
      },
      PENDINGS: {
        TITLE: "Mantenimientos Pendientes",
        DESCRIPTION: "Seleccione el vehículo y escriba el período",
        STATUS: "Estado",
        SELECT_STATUS: "Seleccione el estado",
        STATUS_SELECT: "Seleccione",
        STATUS_UP_TO_DATE: "Al día",
        STATUS_PROVIDE: "Providenciar",
        STATUS_DELAYED: "Atrasado",
        STATUS_COMPLETED: "Completado",
        SEARCH: "Buscar",
      },
      REGISTER_KM: {
        TITLE: "Registro de cuentakilómetros",
        DESCRIPTION: "Para realizar el registro de KM, seleccione el vehículo y complete la información",
        REGISTER: "Registrar",
        SEARCH_FILTER: "Búsqueda / Filtro",
        SEARCH: "Buscar",
      },
      SHIPPING: {
        TITLE: "Seguimiento de ítems",
        DESCRIPTION: "Visualice todos los ítems registrados, puede filtrar por vehículo, ítem y/o estado",
        ITEMS: "Ítems",
        SELECT_ITEM: "Seleccione un ítem",
        STATUS: "Estado",
        SELECT_STATUS: "Seleccione el estado",
        SEARCH: "Buscar",
        VEHICLE_ITEMS: "Ítems de vehículos",
        VEHICLE: "Vehículo",
        ITEM: "Ítem",
        HOURS: "Horas",
        EDIT: "Editar",
        DELETE: "Eliminar",
        CONFIRM_DELETE: "Confirmar eliminación",
        CONFIRM_DELETE_MESSAGE: "¿Está seguro de que desea eliminar este ítem?",
        CANCEL: "Cancelar",
      }
    },
    PREVIEWS: {
      CREATE_LICENSED: {
        PAGE_TITLE: "Crear Licenciatario",
        PAGE_SUBTITLE: "Configure identidad visual y parámetros",
        SAVE: "Guardar",
        SAVING: "Guardando...",
        SAVED: "¡Guardado!",
        TABS: {
          LICENSEE: "Licenciatario",
          IMAGES: "Imágenes",
          GENERAL_COLORS: "Colores Generales",
          MENU: "Menú",
          CARDS: "Tarjetas",
          FILTERS: "Filtros",
          TABLES: "Tablas",
          BUTTONS: "Botones",
        },
        THEME: {
          LIGHT: "Light",
          DARK: "Dark",
        },
        LICENSEE: {
          SECTION_TITLE: "Datos del Licenciatario",
          LICENSED_ID_LABEL: "ID del Licenciatario",
          LICENSED_ID_PLACEHOLDER: "Ex: 4939",
          PLATFORM_NAME_LABEL: "Nombre de la Plataforma",
          PLATFORM_NAME_PLACEHOLDER: "Ex: Olhar Fixo v3",
          PHRASE_LABEL: "Frase / Eslogan",
          PHRASE_PLACEHOLDER: "Ex: Ayudando a crecer su empresa",
          DOMAIN_LABEL: "Dominio",
          PHONE_LABEL: "Teléfono",
          CENTRAL_PHONE_LABEL: "Teléfono de la Central",
          IOS_LINK_LABEL: "Enlace iOS App Store",
          ANDROID_LINK_LABEL: "Enlace Android Play Store",
          LANGUAGE_LABEL: "Idioma",
          LANG_PT_BR: "Português (BR)",
          LANG_EN_US: "English (US)",
          LANG_ES: "Español",
        },
        IMAGES: {
          SECTION_TITLE: "Imágenes del Sistema",
          COMPANY_LOGO_LABEL: "Logo de la Empresa",
          COMPANY_LOGO_DESC: "Se muestra en login y barra de navegación",
          HOME_SCREEN_LABEL: "Imagen de la Pantalla Inicial",
          HOME_SCREEN_DESC: "Imagen de portada en la pantalla de login",
          CONDENSED_MENU_LABEL: "Menú Condensado",
          CONDENSED_MENU_DESC: "Ícono para menú colapsado",
          FAVICON_LABEL: "Favicon",
          FAVICON_DESC: "Ícono de la pestaña del navegador",
        },
        COLORS: {
          SECTION_TITLE: "Colores Generales",
          THEME: "Tema",
          BACKGROUNDS: "Fondos",
          TEXTS: "Textos",
          BORDERS: "Bordes",
          STATUS: "Estado",
        },
        PREVIEW: {
          REAL_TIME: "Vista previa en tiempo real",
          GENERAL: "General",
          LOGIN: "Login",
          BOTH: "Ambos",
          LOGIN_SCREEN: "Pantalla de Login",
          GENERAL_PREVIEW: "Vista Previa General",
        },
        ERRORS: {
          REQUIRED_FIELDS: "Complete los campos obligatorios: licensedId, domain y platformName",
        },
      },
    },
    TOOLTIPS: {
      DASHBOARD:
        "Visión general de todos los datos de la flota, incluyendo estado de los vehículos, KPIs y gráficos de análisis.",
      DASHBOARD_CARDS_ACTIVE_VEHICLES:
        "Indica la cantidad de vehículos rastreados, según el filtro de grupo seleccionado.",
      DASHBOARD_CARDS_TOTAL_ODOMETER:
        "Indica la suma de los odómetros de los vehículos rastreados, según los filtros de grupo y período seleccionados.",
      DASHBOARD_CARDS_KM_BUSINESS_HOURS:
        "Indica la suma de los odómetros de los vehículos rastreados que circularon dentro del horario comercial (por defecto: de lunes a viernes, de 8:00 a 18:00), según los filtros de grupo y período seleccionados.",
      DASHBOARD_CARDS_KM_OUTSIDE_HOURS:
        "Indica la suma de los odómetros de los vehículos que circularon fuera del horario comercial (por defecto: antes de las 8:00 o después de las 18:00 en días laborables, cualquier horario los fines de semana), según los filtros de grupo y período seleccionados.",
      DASHBOARD_CARDS_ENGINE_TIME:
        "Indica la suma de los tiempos en que los vehículos estuvieron encendidos y en movimiento, según los filtros de grupo y período seleccionados.",
      DASHBOARD_CARDS_IDLE_TIME:
        "Indica la suma de los tiempos en que los vehículos estuvieron encendidos pero detenidos (considerado a partir de 2 minutos en el mismo lugar), según los filtros de grupo y período seleccionados.",
      DASHBOARD_CARDS_OFF_TIME:
        "Indica la suma de los tiempos en que los vehículos estuvieron apagados, según los filtros de grupo y período seleccionados.",
      DASHBOARD_CARDS_SPEED_LIMIT_DISTANCE:
        "Indica la suma de las posiciones recorridas por encima de la velocidad reglamentaria de la vía, según los filtros de grupo y período seleccionados.",
      DASHBOARD_CARDS_COMPANY_SPEED_LIMIT_DISTANCE:
        "Indica la suma de las posiciones recorridas por encima de la velocidad definida por la empresa (límite urbano por defecto: 80 km/h, límite en carretera por defecto: 120 km/h), según los filtros de grupo y período seleccionados.",

      DASHBOARD_CHARTS_VEHICLE_STATUS:
        "Muestra la actividad de los vehículos de la flota (encendido, apagado, detenido, en movimiento) y señala anomalías en el rastreo como problemas de GPS, retrasos de posicionamiento y comunicación con el rastreador.",
      DASHBOARD_CHARTS_QUICK_CONTACTS:
        "Permite que el usuario tenga las opciones de contacto de Movyx al alcance de la mano: sucursal regional, consultor Movyx y centro de atención 24/7.",
      DASHBOARD_CHARTS_DRIVERS_RANKING:
        "Ranking de conductor o vehículo que puntúa al conductor/vehículo con peor conducción, basado en eventos y sus pesos. Útil para identificar comportamientos de riesgo en la flota.",
      DASHBOARD_CHARTS_MOST_ACTIVE_VEHICLES:
        "Indicadores que señalan los vehículos con mayor circulación (vehículo encendido en movimiento). Métrica útil para equilibrar el uso de la flota y aumentar la eficiencia operativa.",
      DASHBOARD_CHARTS_MOST_IDLE_VEHICLES:
        "Proporciona métricas sobre los vehículos con mayor inactividad (encendidos sin movimiento). Útil para reducir costos operativos, aumentar la eficiencia y planificar mantenimientos.",
      DASHBOARD_CHARTS_OUTSIDE_HOURS_USAGE:
        "Indica el uso de los vehículos fuera del horario definido por la empresa (en km). Útil para identificar tanto el uso indebido del vehículo como situaciones excepcionales en la operación.",
      DASHBOARD_CHARTS_WEEKLY_CIRCULATION:
        "Indicador que muestra la suma de la circulación de los vehículos de la flota por período (en km), segmentado por días de la semana (de lunes a domingo).",
      DASHBOARD_CHARTS_SPEED_LIMIT_EXCESS:
        "Muestra cuánto están superando la velocidad los vehículos, ya sea el límite definido por la empresa o el límite reglamentario de la vía. Útil para la gestión de seguridad.",

      MINHA_FROTA:
        "Consulte el estado en tiempo real de todos los vehículos de su flota con información detallada de ubicación y operación. Visualice en mapa o en cuadrícula con filtros por placa, grupo, estado, ignición, velocidad, conductor y ubicación.",
      POSICOES_DETALHADAS:
        "Acompañe la posición detallada de cada vehículo con historial de movimientos desde el inicio del día. Permite aplicar filtros para otros períodos y realizar acciones específicas.",
      GRID_JOURNEY_WORK:
        "Analice las jornadas de trabajo de los vehículos con información sobre rutas, duraciones y eficiencia operativa. Visualice los detalles del trayecto desde el origen hasta el destino.",
      GRID_SPEED_CONTROL:
        "Monitoree eventos de exceso de velocidad y velocidad por encima del límite, generando informes de seguridad. Filtre por agrupación de vehículos, tipo de ocurrencia y período de análisis.",
      GRID_VISIT_AMOUNT:
        "Acompañe puntos de visita y parada con análisis del tiempo dedicado en cada lugar. Identifique qué vehículos realizaron visitas con inicio, fin y duración de cada una.",
      GRID_PERIOD_VISITS:
        "Visualice visitas agrupadas por período con estadísticas y métricas de desempeño. Filtre por tiempo mínimo de permanencia y período específico.",
      GRID_PROTOCOLS:
        "Consulte los protocolos y procedimientos registrados para cada evento de operación, incluyendo protocolos automáticos, generados por evento o por atención.",
      APELIDO:
        "Permite al usuario asignar un nombre al vehículo, como un código de flota o una descripción.",
      RADAR:
        "Visualización en mapa que se actualiza automáticamente con todos los vehículos activos, filtrada por grupos y períodos. Se abre en una ventana independiente del navegador.",
      VEICULO_MAIS_PROXIMO:
        "Funcionalidad de geolocalización que permite buscar el vehículo más cercano a una dirección, otro vehículo o un punto de visita. Incluye información de distancia y tiempo de llegada.",
      CONTROL_POINT:
        "Gestione puntos de control y acceso, monitoreando pasos y eventos asociados. Permite registrar lugares donde los vehículos realizan paradas y visitas.",
      ELETRONIC_FENCES:
        "Configure y monitoree cercas electrónicas (geocercas) para alertas de entrada y salida de zonas. Usada para seguridad, control de flotas y gestión logística.",
      RISK_AREA:
        "Identifique áreas de riesgo con base en el historial de eventos y el comportamiento de conducción. El sistema señala cuando los vehículos entran o salen del área delimitada.",
      VEHICLES_CONFIGURATION:
        "Configure propiedades y parámetros de los vehículos de la flota, horarios comerciales, límites de velocidad y otras referencias.",
      DRIVERS_MANAGEMENT:
        "Gestione datos de conductores, documentos, historial de eventos y desempeño. Incluya datos complementarios y defina permisos de conducción por vehículo.",
      USERS_GROUPS:
        "Organice usuarios en grupos para control de acceso y permisos. El usuario principal puede crear y gestionar accesos limitados de otros usuarios.",
      VEHICLES_GROUPS:
        "Agrupe vehículos por criterios operativos para un análisis y gestión simplificados. Configure parámetros específicos, genere informes automatizados y defina referencias.",
      VEHICLE_DETAILS:
        "Información detallada del vehículo, incluyendo especificaciones técnicas, documentación, historial y ubicación. Visualice nivel de batería, estado de la ignición, velocidad, odómetro y vista de calle.",
      DRIVER_DETAILS:
        "Datos completos del conductor, incluyendo licencias, historial de eventos y desempeño. Incluya información complementaria y permisos de conducción.",
      REPORTS:
        "Genere informes personalizados con datos de operación, seguridad y eficiencia de la flota. Incluye desplazamiento, posicionamiento, distancia recorrida, visitas y control de velocidad.",
      SETTINGS:
        "Configure preferencias del sistema, notificaciones y parámetros de operación. Cambie horarios comerciales, límites de velocidad y otras configuraciones de la flota.",
      USER_PROFILE:
        "Gestione su perfil de usuario, cambiando datos personales y preferencias. También permite cambiar la contraseña y gestionar la información de la cuenta.",
      HELP:
        "Centro de ayuda con documentación, tutoriales y soporte técnico. Acceso a información sobre todas las funcionalidades del sistema.",
      POINT_OF_VISIT:
        "Registre lugares donde los vehículos realizan paradas y visitas (proveedores, clientes, puntos de interés). Facilita la identificación cuando la dirección se sustituye por el nombre del punto.",
      USER_PROFILE_CLIENT:
        "Defina información del usuario como datos personales y preferencias de acceso.",
      COMPANY_INFO:
        "Muestra la información de la empresa registrada, permitiendo consultar los datos.",
      CHANGE_PASSWORD:
        "Cambie la contraseña de su cuenta de usuario para mayor seguridad.",
      PROTOCOLS:
        "Pantalla que permite la consulta de protocolos generados, ya sean automáticos, generados por evento o por atención.",
      LOGS:
        "Registro de actividades (log) que permite consultar todas las acciones realizadas por el usuario en el sistema Movyx Safe.",
      GROUPS:
        "Pantalla que permite crear, editar y administrar grupos de vehículos y su configuración específica, permitiendo la generación de informes automatizados y la configuración de parámetros y referencias para informes y paneles.",
      BIND_VEHICLES:
        "Permite asignar un vehículo a un grupo y también reasignar vehículos de un grupo a otro.",
      GROUP_USERS:
        "Gestiona los permisos de los usuarios (creados dentro de la cuenta del cliente) para visualizar y administrar grupos específicos.",
      POSITION:
        "Función que permite acceder al historial de posicionamiento del vehículo para un período especificado.",
      DISTANCE:
        "Consulta que permite determinar la distancia total recorrida por un vehículo en un intervalo de tiempo específico, registrando los puntos de partida y llegada, incluyendo sus respectivos lugares de inicio y fin.",
      MAINTENANCE_ITEM: "Pantalla utilizada para registrar y gestionar los ítems de mantenimiento, permitiendo crear, editar, desactivar y visualizar todos los componentes que forman parte de los servicios",
      MAINTENANCE_SCHEDULING: "Pantalla destinada a la programación de los mantenimientos, donde el usuario define fechas, vehículos o equipos, responsables y la periodicidad de las intervenciones que deben realizarse",
      MAINTENANCE_SHIPPING: "Pantalla enfocada en el control del envío y recepción de piezas o equipos para mantenimiento externo, registrando envíos, transportistas, plazos y el estado logístico de cada ítem",
      MAINTENANCE_REGISTER: "Pantalla responsable del registro detallado de los mantenimientos realizados, incluyendo la descripción del servicio, las piezas utilizadas, las horas trabajadas, los costos y el técnico responsable de la ejecución",
      MAINTENANCE_PENDING: "Pantalla que lista todos los mantenimientos pendientes, permitiendo filtrar, priorizar y acompañar las actividades que aún necesitan ser ejecutadas, aprobadas o programadas en el flujo de mantenimiento",
      MAINTENANCE_COMPLETED: "Pantalla que presenta el historial de los mantenimientos completados, facilitando consultas, auditorías y la generación de informes sobre el desempeño, los costos y el historial de los equipos o vehículos",
    },
  },
};
